var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssistivNew = function SvgAssistivNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 977 240"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#assistiv-new_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M120 240c66.274 0 120-53.726 120-120S186.274 0 120 0 0 53.726 0 120s53.726 120 120 120"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#assistiv-new_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 124.35,
    cy: 133.139,
    r: 160.381,
    fill: "url(#assistiv-new_svg__c)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#assistiv-new_svg__d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.365,
    cy: -27.242,
    r: 97.986,
    fill: "#99CAFF"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    filter: "url(#assistiv-new_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.63 54.496c1.971-3.413 6.897-3.413 8.868 0l18.041 31.25c6.724 11.644-18.208 84.665-84.964 84.665-3.942 0-6.405-4.266-4.434-7.679z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.988 162.732c1.97 3.413-.493 7.68-4.434 7.68h-57.528c-1.891 0-3.314-1.728-2.889-3.571 4.919-21.359 16.019-40.35 31.311-54.985 1.378-1.319 3.611-.961 4.565.691z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M348.3 48.692h21.909L431.514 191H402.57l-13.266-32.562h-61.707L314.733 191h-28.341zm32.16 88.038-21.909-57.888-22.311 57.888zm116.792-16.482q-3.216-4.221-8.844-7.236-5.628-3.216-12.261-3.216-5.829 0-10.653 2.412t-4.824 8.04 5.226 8.04q5.427 2.211 15.678 4.623a83 83 0 0 1 10.854 3.216q5.628 2.01 10.05 5.427 4.623 3.216 7.437 8.241 2.814 4.824 2.814 11.859 0 8.844-3.417 15.075-3.216 6.03-8.844 9.849-5.427 3.819-12.864 5.427-7.236 1.809-15.075 1.809-11.256 0-21.909-4.02-10.653-4.221-17.688-11.859l15.879-14.874q4.02 5.226 10.452 8.643t14.271 3.417q2.613 0 5.226-.603 2.814-.603 5.025-1.809 2.412-1.407 3.819-3.618t1.407-5.427q0-6.03-5.628-8.643-5.427-2.613-16.482-5.226a97 97 0 0 1-10.653-3.015q-5.025-2.01-9.045-5.025a24.3 24.3 0 0 1-6.432-7.839q-2.412-4.623-2.412-11.457 0-8.04 3.216-13.869 3.417-5.829 8.844-9.447 5.427-3.819 12.261-5.628a54.8 54.8 0 0 1 14.07-1.809 58.4 58.4 0 0 1 20.301 3.618q10.05 3.618 15.879 11.055zm89.312 0q-3.216-4.221-8.844-7.236-5.628-3.216-12.261-3.216-5.829 0-10.653 2.412t-4.824 8.04 5.226 8.04q5.427 2.211 15.678 4.623a83 83 0 0 1 10.854 3.216q5.628 2.01 10.05 5.427 4.623 3.216 7.437 8.241 2.814 4.824 2.814 11.859 0 8.844-3.417 15.075-3.216 6.03-8.844 9.849-5.427 3.819-12.864 5.427-7.236 1.809-15.075 1.809-11.256 0-21.909-4.02-10.653-4.221-17.688-11.859l15.879-14.874q4.02 5.226 10.452 8.643t14.271 3.417q2.613 0 5.226-.603 2.814-.603 5.025-1.809 2.412-1.407 3.819-3.618t1.407-5.427q0-6.03-5.628-8.643-5.427-2.613-16.482-5.226a97 97 0 0 1-10.653-3.015q-5.025-2.01-9.045-5.025a24.3 24.3 0 0 1-6.432-7.839q-2.412-4.623-2.412-11.457 0-8.04 3.216-13.869 3.417-5.829 8.844-9.447 5.427-3.819 12.261-5.628a54.8 54.8 0 0 1 14.07-1.809 58.4 58.4 0 0 1 20.301 3.618q10.05 3.618 15.879 11.055zm36.85-25.728h24.12V191h-24.12zm-3.417-32.763q0-5.829 4.221-10.05 4.422-4.422 11.055-4.422t11.055 4.221q4.623 4.02 4.623 10.251t-4.623 10.452q-4.422 4.02-11.055 4.02t-11.055-4.221q-4.221-4.422-4.221-10.251m109.661 58.491q-3.216-4.221-8.844-7.236-5.628-3.216-12.261-3.216-5.829 0-10.653 2.412t-4.824 8.04 5.226 8.04q5.427 2.211 15.678 4.623a83 83 0 0 1 10.854 3.216q5.628 2.01 10.05 5.427 4.623 3.216 7.437 8.241 2.814 4.824 2.814 11.859 0 8.844-3.417 15.075-3.216 6.03-8.844 9.849-5.427 3.819-12.864 5.427-7.236 1.809-15.075 1.809-11.256 0-21.909-4.02-10.653-4.221-17.688-11.859l15.879-14.874q4.02 5.226 10.452 8.643t14.271 3.417q2.613 0 5.226-.603 2.814-.603 5.025-1.809 2.412-1.407 3.819-3.618t1.407-5.427q0-6.03-5.628-8.643-5.427-2.613-16.482-5.226a97 97 0 0 1-10.653-3.015q-5.025-2.01-9.045-5.025a24.3 24.3 0 0 1-6.432-7.839q-2.412-4.623-2.412-11.457 0-8.04 3.216-13.869 3.417-5.829 8.844-9.447 5.427-3.819 12.261-5.628a54.8 54.8 0 0 1 14.07-1.809 58.4 58.4 0 0 1 20.301 3.618q10.05 3.618 15.879 11.055zm22.58-6.432V94.52h16.884V66.581h23.718V94.52h24.12v19.296h-24.12v44.823q0 6.432 2.211 10.653 2.412 4.221 10.452 4.221 2.412 0 5.226-.402 2.814-.603 5.025-1.608l.804 18.894q-3.216 1.206-7.638 1.809-4.422.804-8.442.804-9.648 0-15.678-2.613-6.03-2.814-9.648-7.437-3.417-4.824-4.824-10.854-1.206-6.231-1.206-13.266v-45.024zm82.579-19.296h24.12V191h-24.12zM831.4 61.757q0-5.829 4.221-10.05 4.422-4.422 11.055-4.422t11.055 4.221q4.623 4.02 4.623 10.251t-4.623 10.452q-4.422 4.02-11.055 4.02t-11.055-4.221q-4.221-4.422-4.221-10.251m42.327 32.763h26.331l25.326 70.35h.402l25.527-70.35h25.527L938.449 191h-25.728z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "assistiv-new_svg__b",
    width: 496.522,
    height: 496.522,
    x: -123.911,
    y: -115.122,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_22_41",
    stdDeviation: 43.94
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assistiv-new_svg__d",
    width: 477.188,
    height: 477.188,
    x: -212.229,
    y: -265.836,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_22_41",
    stdDeviation: 70.304
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assistiv-new_svg__e",
    width: 163.356,
    height: 146.596,
    x: 40.144,
    y: 39.633,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.758,
    dy: 1.758
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.03
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22_41"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_22_41",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assistiv-new_svg__c",
    x1: 115.342,
    x2: 204.32,
    y1: 133.139,
    y2: 325.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "assistiv-new_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    fill: "#fff",
    rx: 120
  })))));
};
export default SvgAssistivNew;